import { Component, ContentChild, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MinuteApprovalRuleMinDTO } from '../../interfaces/minute-request-approval-rule.interface';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MinuteRequestApprovalRuleDetailComponent } from '../minute-request-approval-rule-detail/minute-request-approval-rule-detail.component';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-minute-request-approval-rule-table',
  templateUrl: './minute-request-approval-rule-table.component.html',
  styleUrls: ['./minute-request-approval-rule-table.component.scss'],
  animations:[
    trigger('rowExpand',[
      state('collapsed,void', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ])
  ]
})
export class MinuteRequestApprovalRuleTableComponent implements OnInit, OnChanges{
  
  @Input()
  public minuteApprovalRules : MinuteApprovalRuleMinDTO[];

  @Input()public canUpdateRule: boolean = true;
  @Input()public canEnableDisableRule: boolean = true;

  @Output()
  public minuteApprovalRuleIdToView = new EventEmitter<number| null>;

  @Output()
  public minuteApprovalRuleToEnableOrDisable = new EventEmitter<MinuteApprovalRuleMinDTO>;

  @Output()
  public minuteApprovalRuleToUpdate = new EventEmitter<MinuteApprovalRuleMinDTO>;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true}) sort: MatSort;

  @ContentChild(MinuteRequestApprovalRuleDetailComponent) minuteApprovalDetail : MinuteRequestApprovalRuleDetailComponent | null;
  
  public selectedMinuteApprovalRuleId: number | null = null;
  public dataSource = new MatTableDataSource<MinuteApprovalRuleMinDTO>([]);
  public tableColumns = [
    'name',
    'priority',
    'enabled',
    'expand'
  ];

  ngOnInit(): void {
      
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setDataSource(this.minuteApprovalRules);
  }

  private setDataSource(documentTypes: MinuteApprovalRuleMinDTO[]): void{
    this.dataSource.data = documentTypes;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  public toggleMinuteApprovalRule(id: number) {
    this.selectedMinuteApprovalRuleId = this.selectedMinuteApprovalRuleId != null && this.selectedMinuteApprovalRuleId === id
    ? null : id;
    this.minuteApprovalRuleIdToView.emit(this.selectedMinuteApprovalRuleId);
  }

  public clickEnableOrDisableMinuteApprovalRule(rule: MinuteApprovalRuleMinDTO) {
    this.minuteApprovalRuleToEnableOrDisable.emit(rule);
  }

  public clickUpdateMinuteApprovalRule(rule: MinuteApprovalRuleMinDTO) {
    this.minuteApprovalRuleToUpdate.emit(rule);
  }
}
